/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type GoalCategory from '@linc-technologies/linced-common/models/goals/category';
import type GoalSubject from '@linc-technologies/linced-common/models/goals/subject';
import type Page from '@linc-technologies/linced-common/models/posts/page';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: milestones.Level.
export default class Level extends Model {
  declare [Type]: 'milestones/level';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare briefLabel: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @belongsTo('posts/page', { async: true, inverse: null })
  declare pageId: AsyncBelongsTo<Page>;

  @alias('pageId')
  declare page: AsyncBelongsTo<Page>;

  @alias('page.id')
  declare page_id: string | null | undefined;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare goalSubjectId: AsyncBelongsTo<GoalSubject>;

  @alias('goalSubjectId')
  declare goalSubject: AsyncBelongsTo<GoalSubject>;

  @attr('string')
  declare goal_subject_id: string | undefined;

  @belongsTo('goals/category', { async: true, inverse: null })
  declare goalCategoryId: AsyncBelongsTo<GoalCategory>;

  @alias('goalCategoryId')
  declare goalCategory: AsyncBelongsTo<GoalCategory>;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare templateId: string;
}
